//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from 'moment-timezone';
import api from "@/services/api";
import SuccessDialog from "@/components/cards/SuccessDialog";
import SuccessDialogPush from "@/components/cards/SuccessDialogPush";
import pdfvuer from "pdfvuer";

export default {
  name: "MasterPatentNew",
  components: { SuccessDialog, SuccessDialogPush, pdf: pdfvuer },
  data() {
    return {
      dialogAdd: false,
      text_color: '',
      title: '',
      message: '',
      link: '',
      timelineData: [
        // { id: 1, event: "Start Project", date: "18/06/2025" },
        // { id: 2, event: "Design Phase", date: "19/06/2025"},
        // { id: 3, event: "Development Phase", date: "23/06/2025"},
        // { id: 4, event: "Testing", date: "28/06/2025"},
        // { id: 5, event: "Deployment", date: "03/07/2025"},
      ],
    };
  },
  async mounted() {
    await this.loadTimeline();
    this.$hideLoader();
  },
  methods: {
    async loadTimeline() {
      this.timelineData = [];
      this.$showLoader();
console.log(this.$route.params.masterpt_id);
const result = await api.gettimelinemasterpt({masterpt_id:this.$route.params.masterpt_id});
  if(result.data.length > 0){
      // this.timelineData = result.data;
result.data.forEach((x,i)=>{
this.timelineData.push(x);
if(JSON.parse(x.change_master_record_data_All).length > 0){
  x.documenttype_code = "";
  x.documenttype_code = (JSON.parse(x.change_master_record_data_All)?.map(item => item.field_name).join(" / ")) || "";
 
}
});
this.$hideLoader();
    }
    this.$hideLoader();
    },
    setupAlertDialogPush(status, title, message, text_color, link) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
      this.link = link;
    },
    setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },
  },
  beforeCreate() {
    this.$store.state.navMenu = true;
  },
};
